import { Fragment, type FC } from 'react';
import { Button } from '@safetywing-tech/feather/button';
import { useFeatureFlagPayload } from 'posthog-js/react';
import { openCallLink } from 'assets/helpers';
import { ParagraphXs } from 'components/Gen.2/Typography';
import { useHandleCompanySignup } from 'hooks/useHandleCompanySignup';
import Markdown from 'react-markdown';
import CustomParallaxImage from './components/CustomParallaxImage';
import {
  Background,
  StarsContainer,
  HeroContainer,
  Heading,
  Pricing,
  Price,
  PriceSub,
  CtaRow,
  MarsBird,
  EarthBird,
  Em
} from './styled';

type Ctas = { type: string; text: string }[];

const Hero: FC = () => {
  const handleCompanySignup = useHandleCompanySignup();

  const heroText =
    (useFeatureFlagPayload('remote-health-hero-text') as string) ??
    '*Health insurance* for remote teams';

  const showPricing = Boolean(
    useFeatureFlagPayload('remote-health-hero-show-pricing') ?? true
  );
  const ctas = (useFeatureFlagPayload('remote-health-hero-ctas') as Ctas) ?? [
    { type: 'company-signup', text: 'Cover my team' },
    { type: 'book-a-call', text: 'Talk to a human' }
  ];

  return (
    <Background>
      <StarsContainer>
        <CustomParallaxImage />
      </StarsContainer>
      <HeroContainer>
        <Heading>
          <Markdown components={{ em: Em }}>{heroText}</Markdown>
        </Heading>
        {showPricing && (
          <Pricing>
            <Price>
              $106<PriceSub>monthly per member</PriceSub>
            </Price>
            <ParagraphXs>For ages 18-39 on the Standard Plan</ParagraphXs>
          </Pricing>
        )}
        <CtaRow>
          {ctas.map(({ type, text }) => (
            <Fragment key={type}>
              {type === 'company-signup' && (
                <Button color="bermuda" onClick={handleCompanySignup}>
                  {text}
                </Button>
              )}
              {type === 'book-a-call' && (
                <Button color="white" onClick={openCallLink}>
                  {text}
                </Button>
              )}
            </Fragment>
          ))}
        </CtaRow>
        <EarthBird />
        <MarsBird />
      </HeroContainer>
    </Background>
  );
};

export default Hero;
